import React from 'react';
import { Route, Routes, useLocation, Navigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import HeadingContainer from '../components/header/HeadingContainer';

import Dashboard from './Dashboard/Dashboard';
import Analytics from './Analytics/Analytics';
import Recommendations from './Recommendations/Recommendations';
import PowerBiChart from './Analytics/components/PowerBiChart';
import AddRecommendation from './Recommendations/AddRecommendation';
import { unOverlayTopSide } from '../utilities/utils';
import { setDrawer } from '../redux/actions/drawerActions';
import { CustomDrawer } from '../global/CustomDrawer';
import Clients from './Clients/Clients';
import SetUpUser from './Profile/SetUpUser';
import EditProfile from './Profile/EditProfile';
import Feedbacks from './Feedbacks/Feedbacks';
import ProfileView from './Profile/ProfileView';
const Home = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const toggleDrawer = (open) => (event) => {
    if (open === false) unOverlayTopSide();
    dispatch(setDrawer(open));
  };
  const [searchParams] = useSearchParams();
   const clientId = searchParams.get("clientid");
  window.clientId = clientId;
  return (
    <>
      <CustomDrawer />
      <HeadingContainer openDialog={toggleDrawer} clientId={clientId} />

      <Routes location={location}>
        {/* /home */}
        <Route index element={<SetUpUser />} />

        {/* /home/userprofile */}
        <Route path="userprofile" element={<ProfileView />} />
        <Route path="editprofile" element={<EditProfile />} />

        {/* /home/clientlist */}
        <Route path="clientlist" element={<Clients />} />

        
        <Route path="feedbacks" element={<Feedbacks />} />

        {/* /home/dashboard */}
        <Route path="dashboard" element={<Dashboard openDialog={toggleDrawer} />} />

        {/* /home/analytics */}
        <Route path="analytics" element={<Analytics openDialog={toggleDrawer} />} />
        <Route path="analytics/chart" element={<PowerBiChart />} />

        {/* /home/recommendations */}
        <Route path="recommendations" element={<Recommendations />} />
        <Route path="recommendations/add" element={<AddRecommendation />} />

        {/* optional: catch-all under /home */}
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </>
  );
};

export default Home;
